/* eslint-disable no-useless-escape --
 * La barra invertida de `<\/script>` es deliberada. Estas plantillas arman un
 * documento HTML completo que se escribe en una ventana nueva para imprimir, y
 * la secuencia </script> sin escapar cerraria el bloque antes de tiempo si este
 * archivo llegara a quedar incrustado en una pagina. En un literal de plantilla
 * `\/` produce `/`, asi que el HTML generado es identico: el escape no cambia
 * la salida, protege el origen.
 */

import { ESTILOS_VISTA_PREVIA, barraVistaPrevia, abrirVistaPrevia } from './vistaPrevia';

// El comprobante de anulacion, en 80 mm.
//
// Vive aparte del comprobante de venta porque documenta otra cosa: que una
// venta se deshizo y el stock volvio al inventario. No lleva timbrado ni
// liquidacion de IVA —no es un documento fiscal— y por eso no comparte
// plantilla con `printComprobante`.
const TITULO_VISTA = 'Comprobante de anulación';


export function openAnulacionTicket(venta, settings) {
    const moneda = settings?.moneda || 'Gs.';
    const nombre = settings?.nombre_negocio || 'Mi Ferretería';
    const ruc = settings?.ruc ? `RUC: ${settings.ruc}` : '';
    const tel = settings?.telefono ? `Tel: ${settings.telefono}` : '';
    const fecha = new Date(venta.fecha).toLocaleString('es-PY');
    const fechaAnulacion = new Date().toLocaleString('es-PY');

    const filas = (venta.detalles || []).map(d => `
        <tr>
            <td style="padding:4px 0;border-bottom:1px dashed #ddd;">${d.producto_nombre || d.producto}</td>
            <td style="text-align:center;padding:4px;">${d.cantidad}</td>
            <td style="text-align:right;padding:4px 0;">${moneda} ${parseFloat(d.subtotal).toLocaleString()}</td>
        </tr>
    `).join('');

    const html = `<!DOCTYPE html>
<html>
<head>
<meta charset="utf-8">
<title>Nota Anulación #${venta.id}</title>
<style>
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: 'Courier New', monospace; font-size: 12px; color: #000; width: 80mm; margin: 0 auto; padding: 8px; }
  .center { text-align: center; }
  .bold { font-weight: bold; }
  .big { font-size: 15px; }
  .anulado { font-size: 18px; font-weight: bold; letter-spacing: 2px; border: 2px solid #000; padding: 4px 8px; display: inline-block; margin: 6px 0; }
  .divider { border-top: 1px dashed #000; margin: 6px 0; }
  table { width: 100%; border-collapse: collapse; font-size: 11px; }
  th { text-align: left; padding: 3px 0; border-bottom: 2px solid #000; font-size: 10px; text-transform: uppercase; }
  @media print { @page { margin: 0; size: 80mm auto; } }
${ESTILOS_VISTA_PREVIA}
</style>
</head>
<body>
${barraVistaPrevia(TITULO_VISTA)}
<div class="center">
  <div class="bold big">${nombre}</div>
  ${ruc ? `<div>${ruc}</div>` : ''}
  ${tel ? `<div>${tel}</div>` : ''}
  <div class="anulado">*** NOTA DE ANULACIÓN ***</div>
</div>

<div class="divider"></div>

<div><span class="bold">Venta Anulada #${venta.id}</span></div>
<div>Fecha original: ${fecha}</div>
<div>Fecha anulación: ${fechaAnulacion}</div>
${venta.cliente_nombre ? `<div>Cliente: ${venta.cliente_nombre}</div>` : '<div>Cliente: Consumidor Final</div>'}
${venta.vendedor_nombre ? `<div>Vendedor: ${venta.vendedor_nombre}</div>` : ''}

<div class="divider"></div>

<div class="bold" style="margin-bottom:4px;">Motivo:</div>
<div>${venta.motivo_anulacion || '—'}</div>

<div class="divider"></div>

<table>
  <thead>
    <tr>
      <th>Producto</th>
      <th style="text-align:center;">Cant.</th>
      <th style="text-align:right;">Subtotal</th>
    </tr>
  </thead>
  <tbody>
    ${filas}
    <tr>
      <td colspan="2" style="padding-top:6px;font-weight:bold;border-top:2px solid #000;">TOTAL ANULADO</td>
      <td style="text-align:right;padding-top:6px;font-weight:bold;border-top:2px solid #000;">${moneda} ${parseFloat(venta.total).toLocaleString()}</td>
    </tr>
  </tbody>
</table>

<div class="divider"></div>
<div class="center" style="font-size:10px;">Stock devuelto al inventario</div>

</body>
</html>`;

    return abrirVistaPrevia(html, { ancho: 420, alto: 720 });
}
